import React from "react";
import '../../App.css'
import TheTrustCard from "../TheTrustCard";
import Roots from "../Roots";

export default function TheTrust(){
    return (
        <>
            <TheTrustCard />
            <Roots />
        </>

    )
}